import(/* webpackMode: "eager", webpackExports: ["ReactScan"] */ "/app/apps/brackets/src/components/core/scan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/app/apps/brackets/src/lib/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/brackets/src/styles/global.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@pickleballinc+react-ui@1.57.0_@floating-ui+react@0.25.4_react-dom@19.2.1_react@19.2.1__5f6a07e6b8fdc1b30fde21333ed44e3f/node_modules/@pickleballinc/react-ui/stylesheets/bundle.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fortawesome+fontawesome-svg-core@6.7.2/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.64.1_@types_3e72b95ceafbd8d17b62a1c8d6ead12b/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.64.1_@types_3e72b95ceafbd8d17b62a1c8d6ead12b/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/.pnpm/sonner@1.7.1_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["EnvironmentBar"] */ "/app/packages/ui/src/components/global/EnvironmentBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBar"] */ "/app/packages/ui/src/components/global/ImpersonationBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/packages/ui/src/components/global/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EverflowLinkDecorator"] */ "/app/packages/ui/src/components/scripts/EverflowLinkDecorator.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/globals.css");
